import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function CSAE() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"CSAE policy"} />
      <MarkdownBlock markdown={TextBlocks.CHILD_SEXUAL_ABUSE_AND_EXPLOITATION_POLICY_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
